import { render, staticRenderFns } from "./regBindBook.vue?vue&type=template&id=3495dec2&scoped=true&"
import script from "./regBindBook.vue?vue&type=script&lang=js&"
export * from "./regBindBook.vue?vue&type=script&lang=js&"
import style0 from "./regBindBook.vue?vue&type=style&index=0&id=3495dec2&lang=scss&scoped=true&"
import style1 from "./regBindBook.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3495dec2",
  null
  
)

export default component.exports